export default class MasterSchemaList {
    constructor({ id: id, code: code, title: title }) {
        this.id = id;
        this.code = code;
        this.title = title;
    }
}
